import { HIGHLIGHT_STYLES } from "../../utils/progressUtils";
import { AlertTriangle, Clock, CheckCircle2, CheckCircle } from "lucide-react";

const ICONS = {
  RED: AlertTriangle,
  YELLOW: Clock,
  GREEN: CheckCircle2,
  DONE_LATE: CheckCircle,
  NORMAL: null,
};

export default function HighlightBadge({ highlight, className = "" }) {
  if (!highlight || highlight.level === "NORMAL" || !highlight.label) return null;
  const style = HIGHLIGHT_STYLES[highlight.level];
  const Icon = ICONS[highlight.level];
  return (
    <span
      data-testid={`highlight-${highlight.level}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10.5px] font-semibold ${style.badge} ${className}`}
    >
      {Icon ? <Icon className="h-3 w-3" strokeWidth={2.2} /> : null}
      {highlight.label}
    </span>
  );
}
